module.exports = __webpack_public_path__ + "media/img/apple-icon-60x60-53a5e5c0d4e570b8042ee69ab8bd2131.png";